import styled from 'styled-components';
import { BlackButton, TypographyStyles, colours, media, spacing } from '@storefront/lib-global';

export const Container = styled.div<{ $widthLimit?: boolean; $isAmplience?: boolean }>`
  margin: 0 auto;
  padding: ${({ $isAmplience }) => ($isAmplience ? `0 ${spacing.S}` : '0')};
  width: 100%;

  @media ${media.greaterThan('lg')} {
    max-width: ${({ $widthLimit }) => ($widthLimit ? `710px` : '100%')};
    padding: 0;
    text-align: center;
  }
`;
export const Fields = styled.div`
  @media ${media.greaterThan('lg')} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;
export const InputContainer = styled.div<{ $fullWidth?: boolean; $halfWidth?: boolean }>`
  margin-top: ${spacing.XXXS};

  @media ${media.greaterThan('lg')} {
    margin-top: ${spacing.XXXXS};
    width: ${({ $fullWidth, $halfWidth }) => {
      switch (true) {
        case $fullWidth:
          return '100%';
        case $halfWidth:
          return '48%';
        default:
          return '340px';
      }
    }};
  }
`;
export const Message = styled.p`
  ${TypographyStyles.Body.Tiny.Regular}
  margin: 0 0 ${spacing.XXXS};

  a {
    ${TypographyStyles.CallToAction.Tiny.SemiBold}
    color: ${colours.BLACK};
  }

  @media ${media.greaterThan('lg')} {
    margin: ${spacing.XXXXS} 0 ${spacing.XXXS};
  }
`;
export const Button = styled(BlackButton)<{ $fullWidth?: boolean; $alignLeft?: boolean }>`
  margin-top: ${spacing.XXXS};
  width: 100%;

  @media ${media.greaterThan('lg')} {
    display: ${({ $alignLeft }) => $alignLeft && 'block'};
    height: 50px;
    margin-top: ${spacing.XS};
    width: ${({ $fullWidth, $alignLeft }) => {
      switch (true) {
        case $fullWidth:
          return '100%';
        case $alignLeft:
          return '48%';
        default:
          return '256px';
      }
    }};
  }
`;
